import {
    Skeleton,
} from 'one-model-local';

import {
    SET,
    RESET,
} from './types';

import {
    Actions,
} from './actions';

export const skeleton = (
    context: any,
    initial?: Skeleton,
) => {
    const initValue = initial || {
        source_skeleton: false,
        subject_skeleton: false,
        callingDestination_skeleton: false
    };

    return (
        state: Skeleton,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;

        let updated = state || initValue;
        switch (type) {
            case SET:
                updated = {
                    ...updated,
                    ...payload
                }
                break;

            case RESET:
                updated = initValue;
                break;
        }
        return updated;
    }
};
